/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'


const styles = {
  root: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;

    div {
      padding: 15px;
      border-radius: 8px;
      border: 1px solid #d3d3d3;

      p {
        font-weight: 500;
        font-size: 0.8rem;
        color: #808080;
        text-transform: uppercase;
      }

      h4 {
        margin-top: 5px;
        margin-bottom: 5px;
        font-weight: 500;
        font-size: 1.2rem;
        font-family: monospace;
      }
    }
  `,
}



const nf = new Intl.NumberFormat('en', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1
})


const RSVPMetricsBar = ({ total, counts }) => {
  return (
    <div css={styles.root}>
      <div>
        <p>Invited</p>
        <h4>{nf.format(total)}</h4>
      </div>
      {['pending', 'confirmed', 'maybe', 'declined'].map(key => (
        <div key={key}>
          <p>{key.charAt(0).toUpperCase()+key.slice(1)}</p>
          <h4>{nf.format(counts[key] || 0)}</h4>
        </div>
      ))}
    </div>
  )
}


export default RSVPMetricsBar